import e from "../managers/braze-instance.js";
import g from "./content-cards-provider-factory.js";
export function requestContentCardsRefresh(r, t) {
  if (e.rr()) return g.er().Ms(r, t);
}
